module.exports = __webpack_public_path__ + "img/wechatpay_success@3x.e3840a9b.png";